import React from 'react';
import PropTypes from 'prop-types';

const InsightsLoading = (props) => {
    const { isChat } = props;

    const randomId = Math.floor(Math.random() * (9999 - 1000 + 1));
    return (
        <svg
            role="img"
            width="100%"
            aria-labelledby="loading-aria"
            viewBox="0 0 400 160"
            preserveAspectRatio="xMidYMid meet"
        >
            <title id="loading-aria">Waiting for the answer...</title>
            <rect
                x="0"
                y="0"
                width="100%"
                height="100%"
                clipPath={`url("#diff-${randomId}")`}
                style={{ fill: `url("#animated-diff-${randomId}")` }}
            ></rect>
            <defs>
                <clipPath id={`diff-${randomId}`}>
                    {!isChat && (
                        <>
                            <rect x="0" y="8" rx="3" ry="3" width="88" height="6" />
                            <rect x="0" y="26" rx="3" ry="3" width="52" height="6" />
                        </>
                    )}
                    <rect x="0" y="56" rx="3" ry="3" width="410" height="6" />
                    <rect x="0" y="72" rx="3" ry="3" width="380" height="6" />
                    <rect x="0" y="88" rx="3" ry="3" width="178" height="6" />
                </clipPath>
                <linearGradient id={`animated-diff-${randomId}`}>
                    <stop
                        offset="0.599964"
                        stopOpacity="1"
                        className="insights-loader-background-color"
                    >
                        <animate
                            attributeName="offset"
                            values="-2; -2; 1"
                            keyTimes="0; 0.25; 1"
                            dur="2s"
                            repeatCount="indefinite"
                        ></animate>
                    </stop>
                    <stop
                        offset="1.59996"
                        stopOpacity="1"
                        className="insights-loader-foreground-color"
                    >
                        <animate
                            attributeName="offset"
                            values="-1; -1; 2"
                            keyTimes="0; 0.25; 1"
                            dur="2s"
                            repeatCount="indefinite"
                        ></animate>
                    </stop>
                    <stop
                        offset="2.59996"
                        stopOpacity="1"
                        className="insights-loader-background-color"
                    >
                        <animate
                            attributeName="offset"
                            values="0; 0; 3"
                            keyTimes="0; 0.25; 1"
                            dur="2s"
                            repeatCount="indefinite"
                        ></animate>
                    </stop>
                </linearGradient>
            </defs>
        </svg>
    );
};
InsightsLoading.propTypes = {
    isChat: PropTypes.bool,
}
InsightsLoading.defaultProps = {
    isChat: false,
};

export default InsightsLoading;
